// import AmericanExpress from "../../assets/images/amex.svg";
// import Apple from "../../assets/images/apple-pay.svg";
// import Mastercard from "../../assets/images/mastercard.svg";
// import Visa from "../../assets/images/visa.svg";
import { Link } from "react-router-dom";
import { PackageNames } from "../../store/interface";
import useProcessGateway from "../../store/Mutations/organisation-useProcessPayment";
import GridLGHidden from "../GridComponent/components/GridLGHidden";
import Header from "../Header/Header";
import Typography from "../Typography/Typography";
import InputField from "../InputField/InputField";
import Divider from "../Divider/Divider";
import Button from "../Button/Button";
import LockIcon from "../../assets/icons/bx-lock-gray.svg";
import TextWithBackButton from "../TextWithBackButton";
import useUpdateOrganization from "../../store/Mutations/useUpdateOrganization";
import useUserCountry from "../../store/Querys/useUserCountry";
import Loading from "../Loading/Loading";
import PickPlanItem from "../PickPlanItem/PickPlanItem";
import usePricingHook, { getMonthFromProductMonthType } from "./usePricingHook";
import { useEffect, useState } from "react";

const CheckoutBox = ({
  backBtnClick,
  oldOrganizationName,
  orgId,
}: {
  backBtnClick?: () => void;
  oldOrganizationName?: string;
  orgId?: string;
}) => {
  const [selectedPlan, setSelectedPlan] = useState<PackageNames>(
    PackageNames["Biennial Subscription"],
  );

  const { data, isPending: isPendingUserCuntry } = useUserCountry();
  const { packagePricing } = usePricingHook(data?.countryCode || "");
  const organisationID =
    orgId || window.localStorage.getItem("checkoutOrganisationID") || "";
  const [selectedLicenses, setSelectedLicenses] = useState(10);
  const [organizationName, setOrganizationName] = useState(
    oldOrganizationName || "",
  );
  const [isOrgNameTouched, setIsOrgNameTouched] = useState(false);
  const [inputValue, setInputValue] = useState<string>("10");
  const [error, setError] = useState(false);
  const [orgNameError, setOrgNameError] = useState(false);

  const showOrganizationName =
    window.localStorage.getItem("accessToken") !== null;

  useEffect(() => {
    if (!isOrgNameTouched && oldOrganizationName) {
      setOrganizationName(oldOrganizationName);
    }
  }, [oldOrganizationName, isOrgNameTouched]);

  const { mutate, isPending } = useProcessGateway({
    onSuccess: (data) => {
      window.location.href = data.sessionUrl;
      window.localStorage.setItem(
        "selectedPlan",
        selectedPlan as unknown as string,
      );
    },
  });

  const { mutate: updateOrganizationMutation } =
    useUpdateOrganization(organisationID);

  const returnPricePreview = (planID: PackageNames) => {
    const plan = packagePricing?.find((item) => item.key === planID);
    const getMultiplier = +getMonthFromProductMonthType(
      plan?.key || PackageNames["Quarterly Subscription"],
    );

    const newPrice = Number(plan?.price) * getMultiplier * selectedLicenses;
    // _________
    const oldPrice =
      Number(plan?.defaultPrice) * getMultiplier * selectedLicenses;

    return (
      <div className="flex gap-4">
        {planID !== PackageNames["Quarterly Subscription"] && (
          <Typography
            type="Body2"
            className="text-dark-grey-5 line-through decoration-[#EA2D71]"
          >
            ${oldPrice.toFixed(3).slice(0, -1)}
          </Typography>
        )}

        <Typography type="Body2">
          ${newPrice.toFixed(3).slice(0, -1)} (billed every {getMultiplier}{" "}
          months)
        </Typography>
      </div>
    );
  };

  return (
    <div className="lg:rounded-20 lg:max-h-90% flex w-full lg:w-[522px] flex-col overflow-hidden bg-[#FBFBFE] lg:bg-white relative">
      {isPendingUserCuntry && <Loading />}
      <div className="overflow-auto  lg:my-24 lg:box-border lg:h-full pb-200 lg:pb-186 h-svh">
        <GridLGHidden>
          <Header backgroundColor="[#FBFBFE]" />
        </GridLGHidden>
        <div className="px-12 lg:px-0 lg:mx-24">
          {backBtnClick ? (
            <TextWithBackButton
              text="Pick a plan"
              backBtnClick={backBtnClick}
            />
          ) : (
            <Typography type="Header3" className="mb-32">
              Pick a plan
            </Typography>
          )}
          {showOrganizationName && (
            <div className="my-24">
              <InputField
                customInputStyles="!border-light-grey-10"
                label="Organization name"
                required
                placeholder="Organization name"
                id="organization-name"
                value={organizationName}
                onChange={(e) => {
                  setIsOrgNameTouched(true);
                  setOrganizationName(e.target.value);
                  setOrgNameError(!e.target.value.trim());
                }}
              />

              {orgNameError && (
                <Typography type="Body2" className="text-talklap-red mt-2 ml-4">
                  Required
                </Typography>
              )}
            </div>
          )}

          <InputField
            customInputStyles="!border-light-grey-10 !border-[2px]"
            type="number"
            label="How many licenses would you like to purchase ?"
            required
            placeholder="10"
            min={10}
            onWheel={(e) => e.currentTarget.blur()}
            onKeyDown={(e) => {
              if (
                !/^[0-9]$/.test(e.key) &&
                e.key !== "Backspace" &&
                e.key !== "Delete" &&
                e.key !== "ArrowLeft" &&
                e.key !== "ArrowRight"
              ) {
                e.preventDefault();
              }
            }}
            onChange={(e) => {
              let value = e.target.value.trim();
              value = value.replace(/[^0-9]/g, "");
              if (value !== "") {
                value = String(parseInt(value, 10));
              }
              setInputValue(value);
              const numericValue = Number(value);
              if (!isNaN(numericValue)) {
                setSelectedLicenses(numericValue);
              }
              if (numericValue > 9 && numericValue < 999) {
                setError(false);
              }
            }}
            value={inputValue}
          />
          {error && (
            <Typography type="Body2" className="text-talklap-red mt-2 ml-4">
              {selectedLicenses > 999
                ? `License count cannot be more than 999.`
                : "Minimum 10 licenses required"}
            </Typography>
          )}
          <Divider className="h-[2px] !bg-light-grey-10" />
          <div className=" lg:mt-32 flex flex-col gap-20 lg:gap-24">
            {packagePricing?.map((item) => (
              <PickPlanItem
                key={item.key}
                planID={item.key}
                monlthlyPrice={item.price}
                discount={item.discountAmount}
                selectedPlan={selectedPlan}
                setSelectedPlan={setSelectedPlan}
              />
            ))}

            <Divider marginY="my-0" />
            {/* <div className="flex flex-col gap-12">
              <label
                className={`border-light-grey-10 focus:outline-primary rounded-2xl  flex cursor-pointer  items-center gap-12  border-[2px] p-12 py-16`}
              >
                <input
                  type="radio"
                  value="card"
                  checked={true}
                  id="radio-btn-card"
                  name="payment-method"
                />
                <Typography type="Body2">Card</Typography>
                <img src={Visa} alt="" />
                <img src={Mastercard} alt="" />
                <img src={AmericanExpress} alt="" />
                <img src={Apple} alt="" />
              </label>
            </div> */}
            <div>
              <Typography type="Body3" className="text-dark-grey-5">
                By picking a plan, you accept our{" "}
                <Link
                  to={"https://talkpal.ai/terms-and-conditions/"}
                  target="_blank"
                  className="underline underline-offset-2 hover:text-[#282828cc]"
                >
                  Terms and Conditions,
                </Link>{" "}
                <Link
                  to={"https://talkpal.ai/privacy-policy/"}
                  target="_blank"
                  className="underline underline-offset-2 hover:text-[#282828cc]"
                >
                  Privacy Policy,
                </Link>{" "}
                and{" "}
                <Link
                  to={"https://talkpal.ai/data-processing-agreement/"}
                  target="_blank"
                  className="underline underline-offset-4 hover:text-[#282828cc]"
                >
                  Data Processing Agreement.
                </Link>{" "}
                Occasionally, we’ll send you our newsletters, with learning tips
                and special offers. You can unsubscribe anytime. *Compared to 3
                Months plan.
              </Typography>
            </div>
          </div>
          <div className="absolute bottom-0 left-0 bg-[#FBFBFE] lg:bg-white flex items-center flex-col gap-20 w-full px-24 max-lg:px-12 pb-20">
            <div className=" w-full">
              <Divider marginY="my-0" className="w-full" />
            </div>

            {returnPricePreview(selectedPlan)}

            <Button
              title="Continue"
              buttonType="primary"
              loading={isPending}
              onClick={() => {
                const trimmedOrgName = organizationName.trim();

                if (selectedLicenses < 10 || selectedLicenses > 999) {
                  setError(true);
                  return;
                }
                if (showOrganizationName && !trimmedOrgName) {
                  setOrgNameError(true);
                  return;
                }

                const isOrgNameChanged =
                  showOrganizationName &&
                  trimmedOrgName !== (oldOrganizationName || "").trim();

                if (isOrgNameChanged) {
                  updateOrganizationMutation({
                    organizationName: trimmedOrgName,
                  });
                }

                mutate({
                  packageName: selectedPlan,
                  organizationId: organisationID,
                  licenseCount: +selectedLicenses,
                  tier: packagePricing?.find(
                    (item) => item.key === selectedPlan,
                  )?.countryTier,
                });
              }}
            />
            <Typography
              type="Body3"
              className="text-dark-grey-5 flex items-center gap-4"
            >
              <img src={LockIcon} alt="" className="w-16 h-16" />
              Cancel anytime
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutBox;
